import CustomFieldsModal from './customFieldsModal';

export default CustomFieldsModal;
